import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { LOOKING_FOR_OPTIONS } from '@/pages/Onboarding/options/LookingFor/LOOKING_FOR_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenLookingFor: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'LookingFor',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const lookingFor = form.watch('looking_for');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['looking_for']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        lookingFor: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>What are you looking for?</OwnAiTitle>
        <OnboardingOptionsList>
          {LOOKING_FOR_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={lookingFor === option.id}
              control={form.control}
              option={option}
              name="looking_for"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`looking-for-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
